export const THEME_MODE_KEY = 'agentteams-theme-mode';
export const THEME_LEGACY_KEY = 'agentteams-theme';
export const DARK_THEME = 'night';
export const LIGHT_THEME = 'winter';

export const themeInitScript = `(function(){
  try {
    var DARK="night",LIGHT="winter";
    var mode=localStorage.getItem("agentteams-theme-mode");
    if(!mode){
      var legacy=localStorage.getItem("agentteams-theme");
      if(legacy==="night"){mode="DARK";}
      else if(legacy==="winter"){mode="LIGHT";}
      else{mode="SYSTEM";}
      localStorage.setItem("agentteams-theme-mode",mode);
    }
    var theme;
    if(mode==="DARK"){theme=DARK;}
    else if(mode==="LIGHT"){theme=LIGHT;}
    else{
      var prefersDark=!!(window.matchMedia&&window.matchMedia("(prefers-color-scheme: dark)").matches);
      theme=prefersDark?DARK:LIGHT;
    }
    var d=document.documentElement;
    d.setAttribute("data-theme",theme);
    d.style.colorScheme=theme===DARK?"dark":"light";
    // base-200 토큰값과 일치(night #151d2e / winter #fafbfd)시켜 CSS 로드 후 톤 점프를 없앤다.
    d.style.backgroundColor=theme===DARK?"#151d2e":"#fafbfd";
  } catch(e) {
    var d=document.documentElement;
    d.setAttribute("data-theme","night");
    d.style.colorScheme="dark";
    d.style.backgroundColor="#151d2e";
  }
})();`;
